export const ACCESS_TOKEN_KEY = "AccessToken";
export const REFRESH_TOKEN_KEY = "RefreshToken";
export const LANGUAGE_KEY = "Language";
export const TRANSACTION_KEY = "Transaction";
export const IS_DOCTOR_LIST_GRID = "IsDoctorListGrid";
